import SplitScreenContent from "../../components/SplitScreenContent";

export const elektronik = {
  title: "Elektronik & Fehlerdiagnose für Porsche-Modelle",
  titleImageUrl: "porsche-engine.jpg",
  meta: {
    title:
      "Porsche Elektronik & Fehlerdiagnose – PIWIS, CAN-Bus, Steuergeräte | WTM Sportwagen",
    description:
      "Elektronikprobleme am Porsche? WTM Sportwagen diagnostiziert & behebt Fehler an 911 (F/G), 964, 993, 996, 997, 991, Boxster & Cayman: PIWIS-Diagnose, CAN-Bus, Steuergeräte, Fensterheber/Verdeck, Batterie & Ladestrom, Codierung & Updates.",
  },
  content: [
    {
      type: "hero_image",
      backgroundImage:
        "https://res.cloudinary.com/donwh3eei/image/upload/v1756323475/gallery/frank_kayser/M10_6747_mnlim4.jpg",
      headline: "Elektronik verstehen. Fehler lösen. Porsche fahren.",
      description:
        "Moderne Porsche verbinden Mechanik mit komplexer Elektronik. Wir finden Ursachen systematisch – mit Messtechnik, PIWIS-Diagnose und Erfahrung – und beheben sie nachhaltig.",
      hasVignette: true,
      overlayOpacity: 0.01,
    },
    {
      type: "text_section_hero",
      // headline: "Elektronik verstehen. Fehler lösen. Porsche fahren.",
      lead: "Moderne wie klassische Porsche verbinden Mechanik mit komplexer Elektronik. Wir finden Ursachen systematisch – mit Messtechnik, PIWIS-Diagnose und Erfahrung – und beheben sie nachhaltig.",
      highlight: "Präzise Diagnose statt Teile-Roulette.",
      spacing: "tight_top_comfortable_bottom",
      size: "lg",
      variant: "primary",
      margin: false,
    },

    {
      type: "split_screen_layout",
      leftImage: "gallery/frank_kayser/M10_6747_mnlim4",
      headline: "Elektronik-Diagnose bei WTM",
      rightContent: (
        <SplitScreenContent
          headline="Systematische Fehlersuche"
          intro="Wir finden die Ursache systematisch – mit professioneller Messtechnik, PIWIS-Diagnose und jahrelanger Erfahrung. Zielgerichtete Reparatur statt kostspieliger Teiletausch-Experimente."
          padding="py-24 px-4 lg:px-24"
          blocks={[
            {
              type: "heading",
              text: "PIWIS & OBD-Diagnose",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Professionelle Diagnose aller Steuergeräte, Sensoren und Aktoren. Wir lesen nicht nur Fehlercodes aus, sondern analysieren die Ursachen systematisch.",
            },
            {
              type: "heading",
              text: "Transparente Dokumentation",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Jede Diagnose wird mit Messwerten und Protokollen dokumentiert. Sie wissen genau, was repariert wurde und warum.",
            },
            {
              type: "heading",
              text: "Deutschlandweiter Service",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Versicherter Hol- und Bringservice deutschlandweit. Elektronikprobleme lösen wir auch bei komplexeren Fällen zuverlässig.",
            },
            {
              type: "component",
              component: "CallToActionWithModalV2",
              props: {
                headline: "Elektronikproblem? Wir finden die Ursache",
                paragraph:
                  "Beschreiben Sie die Symptome oder bereits gelesene Fehlercodes. Wir melden uns mit einer ersten Einschätzung.",
                darkMode: false,
                margin: false,
              },
            },
          ]}
        />
      ),
      imageAlt:
        "WTM Sportwagen Elektronik-Diagnose - Systematische Fehlersuche",
      navbarHeight: 0,
    },

    {
      type: "split_screen_layout",
      leftImage: "gallery/frank_kayser/M10_6850_1_g9tvpo",
      headline: "Was wir reparieren",
      rightContent: (
        <SplitScreenContent
          headline="Alle Elektronik Bereiche"
          intro="Von der klassischen Fehlersuche bis zur Steuergeräte-Programmierung – wir decken alle typischen Elektronikprobleme ab und liefern nachhaltige Lösungen."
          padding="py-24 px-4 lg:px-24"
          blocks={[
            {
              type: "heading",
              text: "Fehlerdiagnose & Messtechnik",
              level: 3,
            },
            {
              type: "paragraph",
              text: "PIWIS/OBD-Diagnose, Sensor- und Aktortest, Leitungsmessungen. Wir lokalisieren Kurzschlüsse, Übergangswiderstände und Massefehler systematisch.",
            },
            {
              type: "heading",
              text: "Fensterheber & Verdeck",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Endanschläge anlernen, Einklemmschutz kalibrieren, Motoren und Sensorik instand setzen. Mechanik und Elektronik perfekt abgestimmt.",
            },
            {
              type: "heading",
              text: "Steuergeräte & CAN-Bus",
              level: 3,
            },
            {
              type: "paragraph",
              text: "CAN-/LIN-Bus-Diagnose, Codierungen nach Umbauten, defekte Module erneuern und anlernen. Kommunikation zwischen allen Systemen sicherstellen.",
            },
            {
              type: "heading",
              text: "Codierung & Updates",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Software-Updates nach Umbauten, Scheinwerfer-Kalibrierung, Schlüssel anlernen. Saubere Integration von Nachrüstungen.",
            },
          ]}
        />
      ),
      imageAlt: "WTM Sportwagen Elektronik - Alle Bereiche",
      navbarHeight: 0,
    },

    {
      type: "split_screen_layout",
      leftImage: "gallery/frank_kayser/L1013370_kbua2l",
      headline: "Für alle Porsche-Modelle",
      rightContent: (
        <SplitScreenContent
          headline="Modellspezifische Expertise"
          intro="Jede Porsche-Generation hat ihre typischen Elektronikprobleme. Unsere Erfahrung mit allen Baureihen spart Zeit und verhindert unnötige Teiletausch-Experimente."
          padding="py-24 px-4 lg:px-24"
          blocks={[
            {
              type: "heading",
              text: "Luftgekühlte Klassiker",
              level: 3,
            },
            {
              type: "paragraph",
              text: "964/993: Fensterheber- und Verdecklogik, Massepunkte, Relaislasten – wir kennen die typischen Schwachstellen der luftgekühlten Generationen.",
            },
            {
              type: "heading",
              text: "Moderne Porsche",
              level: 3,
            },
            {
              type: "paragraph",
              text: "996/997/991: Zündschloss-Themen, Kombiinstrument, Airbag-Systeme, Batterie-Management – auch bei komplexer Elektronik finden wir die Ursache.",
            },
            {
              type: "heading",
              text: "Boxster & Cayman",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Verdeck-Mikroschalter, Türsteuergeräte, Fensterabsenkung – die Mittelmotoren haben ihre eigenen elektronischen Eigenheiten.",
            },
            {
              type: "component",
              component: "IconBulletListV2",
              props: {
                headline: "Warum Elektronik-Diagnose bei WTM?",
                items: [
                  "Systematische Diagnose statt kostspieliger Teiletausch-Experimente",
                  "PIWIS-Diagnose und professionelle Messtechnik",
                  "Transparente Dokumentation mit Messwerten und Protokollen",
                  "Versicherter Hol- und Bringservice deutschlandweit",
                ],
                highlightedIndices: [0, 1],
                icon: "check",
              },
            },
            {
              type: "component",
              component: "CallToActionWithModalV2",
              props: {
                headline: "Elektronikproblem? Wir finden die Ursache",
                paragraph:
                  "Beschreiben Sie die Symptome oder bereits gelesene Fehlercodes. Wir melden uns mit einer ersten Einschätzung und Lösungsvorschlag.",
                darkMode: false,
                margin: false,
              },
            },
          ]}
        />
      ),
      imageAlt: "WTM Sportwagen Elektronik - Alle Porsche-Modelle",
      navbarHeight: 0,
    },

    {
      type: "relevant-posts",
      postSlugs: ["porsche-elektronik-sensoren-fehlerquellen"],
      headline: "Werkstatt Journal: Elektrik & Diagnose",
      darkMode: false,
    },
  ],
};
